import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

/*
  Generated class for the ConsumerRewardHandlerProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class ConsumerRewardHandlerProvider {
  url: any;
  token: any;
  categoryId: any = 0;
  rewardId: any = 0; 

  rewards: any=[];
  selectedReward: any={};

  constructor(
  		  public http: Http,
		    public globals: Globals,
      	public storage: Storage,
      	public httpHelper: HttpHelper) {    
  }

  updateReward(reward){
    for (var i = this.rewards.length - 1; i >= 0; i--) {
      if(this.rewards[i].Id == reward.Id){
        Object.assign(this.rewards[i], reward);  
      }
    }
  }

  removeRewardFromList(id){
    for (var i = this.rewards.length - 1; i >= 0; i--) {
      if(this.rewards[i].Id==id){
        this.rewards.splice(i, 1);                        
        break;
      }      
    }
  }

  getRewards(params){	
	  this.url = this.globals.dataUrl + 'consumerReward/whiskey/' + this.globals.whiskeyId +                                   
                                      '/v2/page/' + params.page +
                                      '/size/' + params.size +
                                      '/filter/' + params.filter;;

    this.storage.get('loginData').then((loginData) => {
      this.token = loginData.access_token

      this.http.get(
        this.url,
        this.httpHelper.configOptionsWithToken(loginData.access_token)
      )
      .map(res => res.json())
      .subscribe(res => {
          if(!this.rewards){
            this.rewards = res.Data;            
          }
          
          if(params.cb) params.cb(res.Data);
      });   
    })
  }  

  getById(params){	
	  this.url = this.globals.dataUrl + 'consumerReward/whiskey/' + this.globals.whiskeyId + '/' + params.id 

    this.storage.get('loginData').then((loginData) => {
      this.token = loginData.access_token

      this.http.get(
        this.url,
        this.httpHelper.configOptionsWithToken(loginData.access_token)
      )
      .map(res => res.json())
      .subscribe(res => {
          this.selectedReward = res.Data[0];
          if(params.cb) params.cb(this.selectedReward);
      });   
    })
  }

  getUsers(params){  
    this.url = this.globals.dataUrl + 'consumerReward/whiskey/' + this.globals.whiskeyId+ '/search' +                                   
                                      '/page/' + params.page  +
                                      '/size/' + params.size  +
                                      '?term=' + params.term;

    this.storage.get('loginData').then((loginData) => {
      this.token = loginData.access_token

      this.http.get(
        this.url,
        this.httpHelper.configOptionsWithToken(loginData.access_token)
      )
      .map(res => res.json())
      .subscribe(res => {
          if(params.cb) params.cb(res.Data);
      });   
    })
  }     

  transferReward(params){
      this.url = this.globals.dataUrl + 'consumerReward/whiskey/' + this.globals.whiskeyId +
                                        '/transfer/' + params.rewardId +
                                        '/to/' + params.toId;

      this.storage.get('loginData').then((loginData) => {
          this.token = loginData.access_token

        this.http
        .put(
          this.url, 
          params, 
          this.httpHelper.configOptionsWithToken(loginData.access_token)
        )
        .map(res => res.json())
        .subscribe(response => {

          if(response.Success)
            this.removeRewardFromList(params.rewardId);

            if(params.cb) params.cb(response);
        }); 
    });             
  }
}



// WEBPACK FOOTER //
// ./src/providers/consumer-reward-handler.ts